<form>
    <textarea id="code" name="code" #myEditor [(ngModel)]="internalQuery" rows="5" cols="300"></textarea>
</form>